<template>
  <v-checkbox
    :data-testid="testId"
    class="pa-2 mt-0 pt-0"
    dense
    hide-details
    color="primary"
    :indeterminate="indeterminate"
    :input-value="checked"
    @change="onChange"
  >
    <template v-slot:label>
      <span class="font-size-md">Select all</span>
    </template>
  </v-checkbox>
</template>

<script>
import {
  toOptionValues,
  areAllValuesSelected,
  isValuesSelectAllIndeterminate,
  applySelectAllToValues,
} from './filterSelectAllUtils';

/**
 * Reusable Select-all checkbox for multi-select filter menus.
 * Works with value-array selection (lb-datatablenew).
 */
export default {
  name: 'FilterSelectAllCheckbox',
  props: {
    /** Visible options: [{ value, ... }] or raw values (only `value` is read) */
    options: { type: Array, default: () => [] },
    /** Currently selected values */
    value: { type: Array, default: () => [] },
    testId: { type: String, default: 'filter-select-all-checkbox' },
  },
  computed: {
    optionValues() {
      return toOptionValues(this.options);
    },
    checked() {
      return areAllValuesSelected(this.optionValues, this.value);
    },
    indeterminate() {
      return isValuesSelectAllIndeterminate(this.optionValues, this.value);
    },
  },
  methods: {
    onChange(checked) {
      this.$emit(
        'input',
        applySelectAllToValues(this.optionValues, this.value, !!checked)
      );
    },
  },
};
</script>
